import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchActiveCVEDetails,
  fetchCVEDetailsGraph,
  fetchActiveCVEDetailsTotal,
  fetchCVEDetailsAction,
  fetchActiveCVEDetailsAction,
  addIpVa,
  fetchRiskTotalFinding
} from "../../actions/vulnerability";
import { Link, useParams, useLocation } from "react-router-dom";
import BasicLineColumn from "../common/apexChart/lineChart";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { Donut } from "react-dial-knob";
import GaugeChart from "react-gauge-chart";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import $, { data } from "jquery";
import KnownsubscribersChart from "../common/dashboard9/knownsubscribersChart";
import { toastr } from "react-redux-toastr";

const ActiveVaDetails = () => {
  const dispatch = useDispatch();
  const ip = useParams();
  const myRef = useRef(null);
  const [filterData, setfilterData] = useState("all");
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [search, setsearch] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [category, setCategory] = useState("all");
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [ipFilter, setIpFilter] = useState("");
  const [searchName, setSearchName] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [limit, setLimit] = useState(10);
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [isModalThree, setModalThree] = useState(false);
  const [Ips, setIps] = useState([]);

  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const userPermission = useSelector(state => {
        return state?.auth?.user?.modulePermissionsConfig?.asm?.e;
    });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  let table = useSelector(
    (state) => state.vulnerability?.cveDetails?.data?.findings
  );

  let totalCount = useSelector((state) => state.vulnerability?.cveTotal?.data);

  const pagination = useSelector(
    (state) => state.vulnerability?.cveDetails?.data
  );

  let scanCompleted = useSelector(
    (state) => state.vulnerability?.scanCompleted
  );
  const executeScroll = (val) => {
    setfilterData(val);
    myRef.current.scrollIntoView(); // run this function from an event handler or pass it to useEffect to execute scroll
  };

  const scanDetails = useSelector(
    (state) => state?.vulnerability?.cveGraph?.data
  );

  const auth = useSelector((state) => state?.auth?.user);
  const iPDetails = useSelector(
    (state) => state?.vulnerability?.cveDetails?.scanDetailArray?.ipDetails
  );

  useEffect(() => {
    fetchActiveCVEDetails(id, dispatch, page, search, ip?.ip, category,limit);
  }, [id, dispatch, page, search, ip?.ip, category,limit]);

  useEffect(() => {
    setsearch(ip?.data)
  }, [ip?.data])

  useEffect(() => {
    setTotalItems(pagination?.totalFindings);
  }, [pagination?.totalFindings]);

  useEffect(() => {
    fetchActiveCVEDetailsTotal(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    fetchCVEDetailsGraph(id, dispatch);
  }, [id, dispatch]);

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event) => {
    if (event == "markAsRemidiated") {
      let ids = [];
      ids.push(_id);
      const data = {
        action: "markAsRemidiated",
        scanNames: selectedIds == 0 ? ids : selectedIds,
        actionNote: "",
        for: "forever",
      };
      fetchActiveCVEDetailsAction(
        id,
        dispatch,
        page,
        search,
        searchName,
        category,
        data
      );
      setSelectedValue("pleaseSelect");
      setActionNote("");
      setSelectedIds([]);
    }
  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      scanNames: selectedIds == 0 ? ids : selectedIds,
    };
    fetchActiveCVEDetailsAction(id, dispatch, page, search, category, searchName, data);
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      scanNames: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchActiveCVEDetailsAction(id, dispatch, page, search, category, searchName, data);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  const handleSearchChange = (e) => {
    const inputValue = e.target.value;
    clearTimeout(handleSearchChange.timeoutId);
    handleSearchChange.timeoutId = setTimeout(() => {
      setSearchName(inputValue);
      setPage(1);
    }, 1000);
  };

  let ipArray = [];
  for (let details = 0; details < scanDetails?.scanDetails?.length; details++) {
    ipArray.push(scanDetails?.scanDetails?.[details]?.length || 0);
  }

  let mapData = table;

  let currentTableData = [];

  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
      if (sessionStorage.getItem('vendorId')) {
        clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `https://api.brandsek.com/api/organisations/${id}/active-vulnerabilities/scan/excel?ipAddress=${ip?.ip}`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}IP Vulnerability Details.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const severity = (val) => {
    if (val < 4) {
      return "Low";
    }
    if (val >= 4 && val < 7) {
      return "Medium";
    }
    if (val >= 7 && val < 9) {
      return "High";
    }
    if (val >= 9) {
      return "Critical";
    }
  };

  const severityBatch = (val) => {
    if (val < 4) {
      return "badge badge-low";
    }
    if (val >= 4 && val < 7) {
      return "badge badge-med";
    }
    if (val >= 7 && val < 9) {
      return "badge badge-high";
    }
    if (val >= 9) {
      return "badge badge-critical";
    }
  };

  const removeKeyword = (index) => {
    let ip = [...Ips];
    ip.splice(index, 1);
    setIps(ip);
  }

  const addIps = () => {
    let val = $("#ips").val()
    setIps([...Ips, val])
    $("#ips").val('')
  }
  const submitIps = () => {
    if (Ips.length === 0) {
      toastr.error("error", "IP is required to proceed.");
      return;
    }
    let ips = {
      "ipAddresses": Ips
    }
    addIpVa(id, dispatch, ips)
    setModalThree('')
    setIps([])
  }

  return (
    <>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1>Active Vulnerability Assessment</h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  {
                    vendorName ?
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{ color: "white" }}
                      >
                        {vendorName}
                      </li> : ''
                  }
                  <li className="breadcrumb-item active" aria-current="page">
                    <Link to="/active-va">Active VA</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Ip details
                  </li>
                </ol>
                <br />
              </nav>
              {/* <p>Grade : {riskScore || "Calculating..."}</p> */}
            </div>
            {auth.accessLevel === "Admin" && (
              <div className="col-md-6 col-sm-12">
                <div
                  className="custom-file"
                  style={{ width: "300px", float: "right", textAlign: 'end' }}
                >
                  <label className="custom-file-label-upload"
                    onClick={() => {
                      setModalThree('Form Wizard modalThree')
                    }}
                  >
                    Add IP Address
                  </label>
                </div>
                      {mapData?.length === 0 ? null : (
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            downloadFile();
                          }}
                          style={{ float: "right" }}
                          href="/add-report"
                          className="btn btn-primary mr-1"
                        >
                          <i
                            className="fa fa-file-excel-o"
                            style={{ color: "black" }}
                          ></i>
                          Download Details
                        </a>
                      )}
              </div>
            )}
          </div>
        </div>

        {typeof scanCompleted !== "undefined" && !scanCompleted && (
          <div className="card border-success">
            <ScanMessage />
          </div>
        )}
        <div className="row clearfix">
          <div className="col-lg-12 col-md-12">
            <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
              <li className="nav-item">
                <a
                  className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("all");
                    setPage(1);
                    setfilterData("all");
                    setSelectedIds([]);
                  }}
                >
                  Current
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("risk-accepted");
                    setPage(1);
                    setfilterData("all");
                    setSelectedIds([]);
                  }}
                >
                  Risk Accepted
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("false-positive");
                    setPage(1);
                    setfilterData("all");
                    setSelectedIds([]);
                  }}
                >
                  False Positive
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("remidiated");
                    setPage(1);
                    setfilterData("all");
                    setSelectedIds([]);
                  }}
                >
                  Remediated
                </a>
              </li>
            </ul>
            <div className="card">
              <div className="body">
                <div className="header" ref={myRef}>
                  <div className="row align-items-center">
                    <div className="col-sm-12" style={{ marginTop: "10px" }}>
                      <h6 className="ip_Address">
                        IP Address <span>{ip?.ip}</span>
                      </h6>
                    </div>
                    <div className="col-sm-3">
                      <select
                        className="custom-select custom-select-sm form-control form-control-sm"
                        value={search}
                        onChange={(e) => {
                          setsearch(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value="all">All</option>
                        <option value="Critical">Critical</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                      </select>
                    </div>
                    {/* <div className="col-sm-3">
                      <input
                        class="form-control form-control-sm ml-0 my-1"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                        onChange={handleSearchChange}
                      />
                    </div> */}
                    
                    <div className="col-sm-2">
                      {selectedIds.length > 1 && userPermission && category === "all" && (
                        <Box sx={{ width: 160 }}>
                          <FormControl fullWidth>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={selectedValue}
                              onChange={(event) => {
                                setAction(event.target.value);
                                snooze("", event.target.value);
                              }}
                            >
                              <MenuItem value="pleaseSelect">
                                Snooze Options
                              </MenuItem>
                              <MenuItem
                                value="riskAccepted"
                                onClick={() => {
                                  addModal();
                                }}
                              >
                                Risk Accepted
                              </MenuItem>
                              <MenuItem
                                value="markAsFalsePositive"
                                onClick={() => {
                                  addModal();
                                }}
                              >
                                False Positive
                              </MenuItem>
                              <MenuItem value="markAsRemidiated">
                                Remediated
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      )}
                      {selectedIds.length > 1 &&
                        (category == "false-positive" ||
                          category == "risk-accepted") && (
                          <button
                            className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                            onClick={() => Unsnoozed("")}
                          >
                            Unsnooze
                          </button>
                        )}
                    </div>
                    <div className="col-lg-12">
                      <div className="table-responsive invoice_list mb-4">
                        <table className="table table-custom spacing5 mb-0">
                          <thead>
                            <tr>
                              {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <th>
                                    <input
                                      type="checkbox"
                                      checked={
                                        selectedIds == 0 ? false : multiCheckTrue
                                      }
                                      onClick={() => {
                                        multicheck(currentTableData);
                                      }}
                                      className="checkUncheck"
                                    />
                                  </th>
                                )}
                              <th style={{ width: "300px" }}>Title</th>
                              {/* <th style={{ width: "150px" }}>Name</th> */}

                              <th style={{ width: "140px" }}>Severity</th>
                              <th style={{ width: "180px" }}>CVE</th>
                              <th style={{ width: "400px" }}>Description</th>
                              {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <th style={{ width: "80" }}>Action</th>
                                )}
                            </tr>
                          </thead>
                          <tbody>
                            {currentTableData?.map((row) => {
                              return (
                                <tr>
                                  {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                    category === "risk-accepted" ||
                                    category === "false-positive") && (
                                      <td>
                                        <input
                                          onClick={() => singleClick(row?._id)}
                                          checked={selectedIds?.includes(
                                            row?._id
                                          )}
                                          type="checkbox"
                                          className="checkUncheck"
                                        />
                                      </td>
                                    )}
                                  <td style={{ whiteSpace: "unset" }}>
                                    <Link to={`/active-va/${row?._id}`}>{row?.name}</Link>
                                  </td>
                                  <td style={{ whiteSpace: "unset" }}>
                                    <span
                                      className={
                                        row?.risk === "Medium"
                                          ? "badge badge-med"
                                          : row?.risk === "Low"
                                            ? "badge badge-low"
                                            : row?.risk === "High"
                                              ? "badge badge-high"
                                              : row?.risk === "Critical"
                                                ? "badge badge-critical"
                                                : "N/A"
                                      }
                                    >
                                      {row?.risk}
                                    </span>
                                  </td>
                                  <td style={{ whiteSpace: "unset" }}>
                                    {row?.cveId}
                                  </td>
                                  <td style={{ whiteSpace: "unset" }}>
                                    {row?.synopsis}
                                  </td>
                                  {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                                    <td>
                                      <Box sx={{ width: 160 }}>
                                        <FormControl fullWidth>
                                          {/* <InputLabel
                                          sx={{ color: "#fff" }}
                                          id="demo-simple-select-label"
                                        >
                                          Action
                                        </InputLabel> */}
                                          <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={selectedValue}
                                            onChange={(event) => {
                                              setAction(event.target.value);
                                              snooze(
                                                row?.scanName,
                                                event.target.value
                                              );
                                            }}
                                          >
                                            <MenuItem value="pleaseSelect">
                                              Snooze Options
                                            </MenuItem>
                                            <MenuItem
                                              value="riskAccepted"
                                              onClick={() => {
                                                addModal();
                                                setLookalikeAppId([row?.scanName]);
                                              }}
                                            >
                                              Risk Accepted
                                            </MenuItem>
                                            <MenuItem
                                              value="markAsFalsePositive"
                                              onClick={() => {
                                                addModal();
                                                setLookalikeAppId([row?.scanName]);
                                              }}
                                            >
                                              False Positive
                                            </MenuItem>
                                            <MenuItem value="markAsRemidiated">
                                              Remediated
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Box>
                                    </td>
                                  )}
                                  {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" || category === "false-positive") && (
                                    <td>
                                      <button
                                        className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                        onClick={() => Unsnoozed(row?.scanName)}
                                      >
                                        Unsnooze
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-flex justify-content-between align-content-center">
                      <div className="dataTables_paginate">
                        {totalItems > 0 && (
                          <Pagination
                            className="pagination-bar"
                            currentPage={page}
                            totalCount={totalItems}
                            pageSize={limit}
                            onPageChange={(page) => {
                              setPage(page);
                            }}
                          />
                        )}
                      </div>
                      {totalItems > 10 && (
                      <select
                      value={limit}
                      onChange={(e)=>{
                        setLimit(e.target.value)
                      }}
                      className="form-control limitSelectBox"
                    >
                      <option value={10}>10 per page</option>
                      <option value={25}>25 per page</option>
                      <option value={50}>50 per page</option>
                      <option value={100}>100 per page</option>
                    </select>
                     )}
                     </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row clearfix"></div>
            </div>
          </div>
        </div>
        <div className="row clearfix"></div>
        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {action == "markAsFalsePositive"
                    ? "Mark As False Positive"
                    : "Risk Accepted"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal("");
                    setActionNote("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <label className="col-lg-6 col-md-12">Snooze for</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            onChange={(e) => setForValue(e.target.value)}
                          >
                            <option value="forever">Forever</option>
                            <option value="3 months">3 Months</option>
                            <option value="6 months">6 Months</option>
                            <option value="12 months">12 Months</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Detail</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setActionNote(e.target.value)}
                            value={actionNote}
                            className="form-control"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12"
                        style={{ marginRight: "28px" }}
                      >
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submit}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          Submit
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModal("");
                            setActionNote("");
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade Form-Wizard-modal ${isModalThree === "Form Wizard modalThree" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add IP Address
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalThree("");
                    setIps([]);
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <div className="form-group d-flex">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="IP Address"
                            name="ips"
                            id="ips"
                            style={{ float: "left", width: "89%" }}
                          />
                          <button
                            type="button"
                            style={{ float: "left", marginLeft: '5px' }}
                            className="btn btn-primary"
                            onClick={() => addIps()}
                          >
                            <i
                              className="fa fa-plus"
                              style={{ fontSize: "22px", color: "black" }}
                            ></i>
                          </button>
                        </div>
                        {Ips && Ips.length > 0 && (
                          <div className="row">
                            <div className="col-md-12">
                              {Ips?.map((keyword, index) => {
                                return (
                                  <label
                                    key={index}
                                    style={{
                                      color: "white",
                                      background: "#43a5f5",
                                      padding: "4px 6px",
                                      margin: "5px 5px"
                                    }}
                                  >
                                    <span>
                                      {keyword}{" "}
                                      <span
                                        className="fa fa-times-circle"
                                        onClick={() =>
                                          removeKeyword(index)
                                        }
                                      ></span>
                                    </span>
                                  </label>
                                );
                              })}
                            </div>
                          </div>)}
                      </div>
                      <div className="col-md-12 text-center">
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          className="btn btn-round btn-primary mr-1"
                          onClick={() => {
                            submitIps()
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActiveVaDetails;